import moment from 'moment'
import { currencyFormat } from './currencyFormat'
// import { generateBarcodeBase64 } from './makeBarCode.util'

export const htmlReplaceContract: (html: string, data: any) => string = (html, data) => {
  if (data.seller === 'coppel') {
    const fecha = moment().locale('es').format('DD/MM/YYYY')
    const fullname = String(data.name) + ' ' + String(data.lastname)
    const direccion: string = data.address
    const identificacion: string = data.rut
    const ciudad: string = data.city
    const marca: string = data.brand
    const modelo: string = data.model
    const imei: string = data.imei

    html = html.replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{direccion}}', direccion)
      .replaceAll('{{identificacion}}', identificacion)
      .replaceAll('{{ciudad}}', ciudad)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{imei}}', imei)
  }

  if (data.seller === 'reuse') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().locale('es').format('DD/MM/YYYY')
    const fullname = String(data.name) + ' ' + String(data.lastname)
    const identificacion: string = data.rut
    const marca: string = data.brand
    const modelo: string = data.model
    const imei: string = data.imei
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const address: string = data.address + ', ' + data.city
    const sbu: string = data.sbu

    html = html.replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{identificacion}}', identificacion)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{imei}}', imei)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{domicilio}}', address)
      .replaceAll('{{sbu}}', sbu)
  }

  if (data.seller === 'falabella') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().locale('es').format('DD/MM/YYYY')
    const fullname = String(data.name) + ' ' + String(data.lastname)
    const identificacion: string = data.rut
    const marca: string = data.brand
    const modelo: string = data.model
    const imei: string = data.imei
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const address: string = data.address + ', ' + data.city
    const sbu: string = data.sbu
    const civilState: string = data.civil_state

    html = html.replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{identificacion}}', identificacion)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{imei}}', imei)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{domicilio}}', address)
      .replaceAll('{{sbu}}', sbu)
      .replaceAll('{{estadoCivil}}', civilState)
  }

  if (data.seller === 'xiaomi') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)
    // const barCodeText1 = '(1)OC2712' + String(moment().locale('es').format('YYYYMMDD') + data.discount_amount + '996')
    // const barCodeText2 = '(2)987654321'
    // const barCodeText3 = '(3)' + String(data.imei)
    // const barCodeText4 = '(4)123456789'

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
      .replaceAll('{{fullname}}', fullname)
      // .replaceAll('{{barCode1}}', String(generateBarcodeBase64(barCodeText1)))
      // .replaceAll('{{barCode2}}', String(generateBarcodeBase64(barCodeText2)))
      // .replaceAll('{{barCode3}}', String(generateBarcodeBase64(barCodeText3)))
      // .replaceAll('{{barCode4}}', String(generateBarcodeBase64(barCodeText4)))
  }

  if (data.seller === 'macstore') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)
    // const barCodeText1 = '(1)OC2712' + String(moment().locale('es').format('YYYYMMDD') + data.discount_amount + '996')
    // const barCodeText2 = '(2)987654321'
    // const barCodeText3 = '(3)' + String(data.imei)
    // const barCodeText4 = '(4)123456789'

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
      .replaceAll('{{fullname}}', fullname)
      // .replaceAll('{{barCode1}}', String(generateBarcodeBase64(barCodeText1)))
      // .replaceAll('{{barCode2}}', String(generateBarcodeBase64(barCodeText2)))
      // .replaceAll('{{barCode3}}', String(generateBarcodeBase64(barCodeText3)))
      // .replaceAll('{{barCode4}}', String(generateBarcodeBase64(barCodeText4)))
  }

  if (data.seller === 'samsung') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const direccion = String(data.address) + ', ' + String(data.city)
    const movil = String(data.movil)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{direccion}}', direccion)
      .replaceAll('{{movil}}', movil)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{DNI}}', data.rut)
  }

  if (data.seller === 'samsung-rom') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const direccion = String(data.address) + ', ' + String(data.city)
    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)

    html = html
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{direccion}}', direccion)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{DNI}}', data.rut)
  }

  if (data.seller === 'motorola') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{direccion}}', data.rut)
      .replaceAll('{{discount}}', discount)
  }

  if (data.seller === 'wom') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
  }

  if (data.seller === 'conecta-peru') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)
    const direccion = String(data.address) + ', ' + String(data.city)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{domicilio}}', direccion)
      .replaceAll('{{email}}', data.email)
      .replaceAll('{{discount}}', discount)
  }

  if (data.seller === 'samsung-mx') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
  }

  if (data.seller === 'oppo') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fecha = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY')
    const fechaHora = moment().tz('America/Mexico_City').locale('es').format('DD/MM/YYYY hh:mm')
    const marca: string = data.brand
    const modelo: string = data.model
    const capacity: string = data.capacity
    const serie: string = data.imei
    const fullname = String(data.name) + ' ' + String(data.lastname)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{fechaHora}}', fechaHora)
      .replaceAll('{{fecha}}', fecha)
      .replaceAll('{{marca}}', marca)
      .replaceAll('{{modelo}}', modelo)
      .replaceAll('{{capacity}}', capacity)
      .replaceAll('{{serie}}', serie)
  }

  if (data.seller === 'claro') {
    console.log('🚀 ~ htmlReplaceContract ~ data', data)

    const fullname = String(data.name) + ' ' + String(data.lastname)
    const discount = currencyFormat(Number(data.discount_amount), import.meta.env.VITE_COUNTRY)

    html = html
      .replaceAll('{{fullname}}', fullname)
      .replaceAll('{{day}}', moment().locale('es').format('DD'))
      .replaceAll('{{month}}', moment().locale('es').format('MM'))
      .replaceAll('{{year}}', moment().locale('es').format('YYYY'))
      .replaceAll('{{rut}}', data.rut)
      .replaceAll('{{discount}}', discount)
      .replaceAll('{{email}}', data.email)
  }

  return html
}
